import axios from 'axios'

import former from './former'

export default {

    mixins: [
        former
    ],

    data () {
        return {
            deleter: {
                submitted: false
            }
        }
    },

    computed: {
        deleterUrl () {
            return ''
        },
        deleterData () {
            return {}
        }
    },

    methods: {

        deleterDelete (append_to_url = null) {
            if (this.deleter.submitted) {
                return
            }

            this.deleter.submitted = true

            axios.delete(
                this.deleterUrl + (append_to_url ? '/' + append_to_url : ''),
                this.deleterData
            )
                .then(response => {
                    console.log('deleter response')
                    console.log(response.data)

                    this.deleterSuccess(response.data)
                })
                .catch(error => {
                    // alert('Sparing misslyckades, vänligen försök igen.')
                    console.log('deleter failed to delete')
                    console.log(error.response)

                    if (error.response && error.response.status === 422) {
                        this.former.errors = error.response.data.errors
                    }
                })
                .then(avar => {
                    this.deleter.submitted = false
                })
        },

        deleterSuccess (data) {

        }

    }
}
